import { Tooltip, TooltipProps } from "@jugl-web/ui-components";
import { FC, ReactNode } from "react";
import { ReactComponent as QuestionMarkIcon } from "./assets/question-mark.svg";

interface InfoIndicatorProps {
  message: ReactNode;
  tooltipPlacement?: TooltipProps["placement"];
}

export const InfoIndicator: FC<InfoIndicatorProps> = ({
  message,
  tooltipPlacement,
}) => (
  <Tooltip
    delay="none"
    placement={tooltipPlacement || "bottom"}
    className="p-4"
    renderTrigger={({ ref, props }) => (
      <div
        ref={ref}
        {...props}
        className="flex h-8 w-8 shrink-0 cursor-help items-center justify-center rounded-full bg-grey-100 transition-colors hover:bg-grey-200"
      >
        <QuestionMarkIcon />
      </div>
    )}
  >
    {message}
  </Tooltip>
);
